import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBooleanGroupExclude: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBooleanGroupExclude"><Path fillRule="evenodd" clipRule="evenodd" d="M16 16H22V2H8V8H2V22H16V16ZM8 8H16V16H8V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBooleanGroupExclude;
